import React from 'react';
import {
    CounterQuickHeader,
    LinkName,
    QuickHeaderButton,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/QuickHeader.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/appState/AppState';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { QuickHeaderBetsIcon } from './BetsIcons';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

interface BetsButtonType {
    currentView: RouteViewType;
    accountView: string | null;
}

export const BetsButton = observer('BetsButton', ({ currentView, accountView }: BetsButtonType) => {
    const { appSportsBookState } = useAppStateContext();
    const common = useCommon();

    const { betSlipState, rab, multibet } = appSportsBookState;

    const { activeBets } = rab;
    const { activeBets: multibetActiveBets } = multibet;
    const { legsIds2 } = betSlipState;

    const starRouter = StarRouter.get(common);

    const isCasino = currentView.name === 'casino';
    const isLiveCasino = currentView.name === 'live-casino';
    const isBetting = accountView === 'betting';

    if (isBetting && (isCasino || isLiveCasino)) {
        return null;
    }

    const handleClick = (): void => {
        starRouter.redirectToBetslip();
    };

    const bets = legsIds2.length + activeBets.length + multibetActiveBets.length;
    const isBetCounter = bets > 0 ? <CounterQuickHeader>{bets}</CounterQuickHeader> : null;

    return (
        <QuickHeaderButton
            data-test='account-navigation-bets-link'
            isActive={isBetting}
            onClick={handleClick}
        >
            <QuickHeaderBetsIcon />
            <LinkName>
                <I18n
                    langKey='quick-header.betslip.label'
                    defaultText='Bets'
                />
            </LinkName>
            {isBetCounter}
        </QuickHeaderButton>
    );
});
